import { __extends, __awaiter, __makeTemplateObject, __decorate, __metadata, __assign as _assign, __generator } from '../../node_modules/tslib/tslib.es6.js';
import '../../node_modules/lit/node_modules/@lit/reactive-element/reactive-element.js';
import { html as x } from '../../node_modules/lit-html/lit-html.js';
import '../../node_modules/lit-element/lit-element.js';
import { property as n } from '../../node_modules/lit/node_modules/@lit/reactive-element/decorators/property.js';
import { state as t } from '../../node_modules/lit/node_modules/@lit/reactive-element/decorators/state.js';
import '../../node_modules/@babel/runtime/regenerator/index.js';
import '../../node_modules/lit/node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import { ifDefined as l } from '../../node_modules/lit-html/directives/if-defined.js';
import getClassName from '../../node_modules/@fmr-ap142296/brick-helpers/dist/src/functions/get-class-name.js';
import { ScopedElementsMixin } from '../utilities/scoped-elements/scoped-elements.mixin.js';
import { PvdSlotifyBaseComponent } from '../pvd-base-component/pvd-slotify-base-component.js';
import { LegacyKeyboardKey, KeyboardKey } from '../pvd-utils/enums/keyboard-key.js';
import { MutationType } from '../pvd-utils/enums/mutation-type.js';
import { debounce } from '../pvd-utils/scripts/debounce.js';
import { FOCUSABLE_SELECTORS } from '../pvd-utils/constants/focusable-selectors.js';
import { getElement } from '../pvd-utils/scripts/get-element.js';

var ModalState;
(function (ModalState) {
    ModalState["closed"] = "closed";
    ModalState["closing"] = "closing";
    ModalState["opened"] = "opened";
    ModalState["opening"] = "opening";
})(ModalState || (ModalState = {}));
var MODAL_WIDTH = { 400: '400', 600: '600', 800: '800' };
var DEFAULT_OPEN = false;
// TODO: [PVD-14511] enable by default in PVD 4
var DEFAULT_PREVENT_HORIZONTAL_SHIFT = false;
var DEFAULT_STATE = ModalState.closed;
var DEFAULT_CLOSE_BTN_TEXT = 'Close dialog';
var DEFAULT_INTERCEPT_CLOSE = false;
var DEFAULT_WIDTH = MODAL_WIDTH[600];
var WINDOW_RESIZE_DELAY = 150;
/**
 * Providence Modal component.
 * @see {@link https://providence.fmr.com/components/modal/modal.html|Modal documentation}
 */
var PvdModal = /** @class */ (function (_super) {
    __extends(PvdModal, _super);
    function PvdModal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * Keeps track of the initial `aria-hidden` value of sibling elements
         */
        _this._initialAriaHiddenValues = [];
        /**
         * The initial `padding-right` value of `document.body`
         *
         * @remarks
         * This value is used to reset the `padding-right` of `document.body` when the
         * component is closed
         */
        _this._prevBodyPaddingRight = '';
        _this.pvdCloseButtonA11yText = DEFAULT_CLOSE_BTN_TEXT;
        _this.pvdInterceptClose = DEFAULT_INTERCEPT_CLOSE;
        _this.pvdOpen = DEFAULT_OPEN;
        _this.pvdPreventBackgroundShift = DEFAULT_PREVENT_HORIZONTAL_SHIFT;
        _this.pvdState = DEFAULT_STATE;
        _this.pvdModalWidth = DEFAULT_WIDTH;
        ////////////////////
        // EVENT HANDLERS //
        ////////////////////
        /**
         * Handles when the Modal is closed
         */
        _this.closeModalEventHandler = function () {
            if (_this.pvdInterceptClose) {
                var event_1 = new CustomEvent('pvd-modal-close-intercept', {
                    detail: { modalRef: _this },
                });
                _this.dispatchEvent(event_1);
            }
            else {
                _this.pvdOpen = false;
            }
        };
        /**
         * Handles when the Modal is opened
         */
        _this.openModalEventHandler = function () {
            _this.pvdOpen = true;
        };
        /**
         * Handles what occurs after the Modal animation is complete
         */
        _this.modalAnimationEndEventHandler = function () {
            _this.pvdOpen ? _this.opened() : _this.closed();
            _this.removeAnimationEndEvent();
        };
        return _this;
    }
    Object.defineProperty(PvdModal, "scopedElements", {
        /////////////////////
        // PRIVATE GETTERS //
        /////////////////////
        get: function () {
            // $namespace-$name-$extendingComponentName
            return {
                'pvd-scoped-icon': customElements.get("".concat(this.namespace, "-icon")),
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PvdModal.prototype, "generatedHeadingId", {
        /**
         * Creates a generated id for the modal heading. used if `pvd-aria-labelledby` is not used.
         * @return a generated id to be used for the heading within the modal
         */
        get: function () {
            if (!this._generatedHeadingId) {
                this._generatedHeadingId = "pvd-modal-heading-id-".concat(PvdSlotifyBaseComponent.generateRandomNumber());
            }
            return this._generatedHeadingId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PvdModal.prototype, "generatedBodyId", {
        /**
         * Creates a generated id for the modal body. used if `pvd-aria-describedby` is not used.
         * @return a generated id to bee used for the body within the modal
         */
        get: function () {
            if (!this._generatedBodyId) {
                this._generatedBodyId = "pvd-modal-body-id-".concat(PvdSlotifyBaseComponent.generateRandomNumber());
            }
            return this._generatedBodyId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PvdModal.prototype, "parentEl", {
        /**
         * The modal's parent element
         *
         * @remarks
         * The value of `parentEl` is either:
         * 1. identical to `pvdParentEl` if `pvdParentEl` is an HTMLElement, OR
         * 2. the result of `document.querySelector` if `pvdParentEl` is a string
         */
        get: function () {
            if (!this._parentEl) {
                this._parentEl = getElement(this.pvdParentEl);
            }
            return this._parentEl;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Use to clear the `parentEl` cache whenever `pvdParentEl` is changed
     */
    PvdModal.prototype.parentElCacheBust = function () {
        this._parentEl = undefined;
    };
    Object.defineProperty(PvdModal.prototype, "returnFocusEl", {
        /**
         * The element that should receive focus when the modal closes
         *
         * @remarks
         * The value of `returnFocusEl` is either:
         * 1. identical to `pvdReturnFocusEl` if `pvdReturnFocusEl` is an HTMLElement, OR
         * 2. the result of `document.querySelector` if `pvdReturnFocusEl` is a string
         */
        get: function () {
            if (!this._returnFocusEl) {
                this._returnFocusEl = getElement(this.pvdReturnFocusEl);
            }
            return this._returnFocusEl;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Use to clear the `returnFocusEl` cache whenever `pvdReturnFocusEl` is changed
     */
    PvdModal.prototype.returnFocusElCacheBust = function () {
        this._returnFocusEl = undefined;
    };
    ////////////
    // STATES //
    ////////////
    /**
     * Handles opening/closing state when `pvdOpen` is changed
     */
    PvdModal.prototype.openStateChange = function () {
        if (this.pvdOpen && this.pvdState === ModalState.closed) {
            // if the user wants the modal to open and the modal is not already open, start opening
            this.bindAnimationEndEvent();
            this.bindWindowResizeEvent();
            this.opening();
        }
        else if (!this.pvdOpen &&
            (this.pvdState === ModalState.opened || this.pvdState === ModalState.opening)) {
            // if the user wants the modal to close and the modal is not already closed, start closing
            this.bindAnimationEndEvent();
            this.removeWindowResizeEvent();
            this.closing();
            // put modal in the closed state (without relying on waiting on an animation end event)
            this.modalAnimationEndEventHandler();
        }
    };
    /**
     * Does anything that needs to be done while the modal is 'opening'
     */
    PvdModal.prototype.opening = function () {
        this.hideSiblingsFromAssistiveTechnology();
        this.hidePageOverflow();
        this.captureLastFocusableEl();
        this.pvdState = ModalState.opening;
        this.triggerModalChangeEvent();
    };
    /**
     * Does anything that needs to be done while the modal is 'closing'
     */
    PvdModal.prototype.closing = function () {
        this.resetSiblingAriaHiddenValues();
        this.pvdState = ModalState.closing;
        this.triggerModalChangeEvent();
    };
    /**
     * Does anything that needs to be done after the modal is 'opened'
     */
    PvdModal.prototype.opened = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updateComplete];
                    case 1:
                        _a.sent();
                        // adds init calculations needed on open
                        this.setMaxHeight();
                        // initial checks for handling content within Modal dialog
                        return [4 /*yield*/, this.checkContent()];
                    case 2:
                        // initial checks for handling content within Modal dialog
                        _a.sent();
                        // add any mutation observers
                        this.addContentChangeObserver();
                        // observe existing observers
                        this.observeMutations();
                        // focus into modal dialog first interactive element
                        this.focusFirstModalElement();
                        this.pvdState = ModalState.opened;
                        this.triggerModalChangeEvent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Does anything that needs to be done after the modal is 'closed'
     */
    PvdModal.prototype.closed = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updateComplete];
                    case 1:
                        _a.sent();
                        // removes any mutation observers
                        this.removeMutationObservers();
                        // focuses back to the last active element before modal opened
                        this.focusLastActiveElement();
                        // resets any `hidden` overflow being set
                        this.resetPageOverflow();
                        this.pvdState = ModalState.closed;
                        this.triggerModalChangeEvent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /////////////
    // METHODS //
    /////////////
    /**
     * Listener for `transitionend` when the modal completes its CSS transition
     */
    PvdModal.prototype.bindAnimationEndEvent = function () {
        this._modalEl.addEventListener(this.whichAnimationEvent(), this.modalAnimationEndEventHandler);
    };
    /**
     * Listener for window `resize` when modal is open
     */
    PvdModal.prototype.bindWindowResizeEvent = function () {
        this._resizeHandler = debounce(this.windowResizeHandler.bind(this), WINDOW_RESIZE_DELAY);
        window.addEventListener('resize', this._resizeHandler);
    };
    /**
     * Removes `transitionend` listener
     */
    PvdModal.prototype.removeAnimationEndEvent = function () {
        this._modalEl.removeEventListener(this.whichAnimationEvent(), this.modalAnimationEndEventHandler);
    };
    /**
     * Removes window `resize` listener
     */
    PvdModal.prototype.removeWindowResizeEvent = function () {
        window.removeEventListener('resize', this._resizeHandler);
    };
    /**
     * Creates mutation observer to watch for content changing within the Modal dialog
     */
    PvdModal.prototype.addContentChangeObserver = function () {
        var _this = this;
        if (!this._contentChangeObserver) {
            this._contentChangeObserver = new MutationObserver(function (mutationsList) {
                _this.contentChangeMutationEventHandler(mutationsList);
            });
        }
    };
    /**
     * Append the Modal as a child of `pvdParentEl`
     *
     * @remarks
     * Moving the Modal as close as possible to the root of the DOM is necessary
     * to allow `hideSiblingsFromAssistiveTechnology` to have an impact
     */
    PvdModal.prototype.appendToParentEl = function () {
        var _a;
        (_a = this.parentEl) === null || _a === void 0 ? void 0 : _a.appendChild(this);
    };
    /**
     * Apply `aria-hidden` to sibling elements to prevent them from being seen by
     * assistive technology when the Modal is open
     */
    PvdModal.prototype.hideSiblingsFromAssistiveTechnology = function () {
        var _this = this;
        // TODO: remove in PVD 4 when `parentEl` has a default value
        if (!this.parentEl)
            return;
        var siblings = Array.from(this.parentEl.children).filter(function (el) { return el !== _this; });
        // save initial aria-hidden values so they can be reset
        this._initialAriaHiddenValues = siblings.map(function (sibling) { return ({
            el: sibling,
            val: sibling.getAttribute('aria-hidden'),
        }); });
        siblings.forEach(function (sibling) { return sibling.setAttribute('aria-hidden', 'true'); });
    };
    /**
     * Reset the `aria-hidden` attribute of sibling elements to what they were
     * before the Modal was opened
     */
    PvdModal.prototype.resetSiblingAriaHiddenValues = function () {
        // TODO: remove in PVD 4 when `parentEl` has a default value
        if (!this.parentEl)
            return;
        this._initialAriaHiddenValues.forEach(function (initialAriaHiddenValue) {
            if (initialAriaHiddenValue.val) {
                initialAriaHiddenValue.el.setAttribute('aria-hidden', initialAriaHiddenValue.val);
            }
            else {
                initialAriaHiddenValue.el.removeAttribute('aria-hidden');
            }
        });
        this._initialAriaHiddenValues = [];
    };
    /**
     * Captures the internal references for the popover elements
     */
    PvdModal.prototype.addElementReferences = function () {
        this._modalEl = this.querySelector(".".concat(this.constructor.namespace, "-modal-root"));
        this._modalDialogEl = this.querySelector('.pvd-modal__dialog');
        this._modalOverlayEl = this.querySelector('.pvd-modal__overlay');
    };
    /**
     * Sets the first and last focusable elements within the popover
     */
    PvdModal.prototype.addFirstLastFocusableElements = function () {
        // do NOT add await this.updateComplete in this method. IE11 cannot handle the power
        var preliminaryFocusableEls = Array.from(this._modalDialogEl.querySelectorAll(FOCUSABLE_SELECTORS));
        // checks to see if any preliminary focusable el has or is within a display:none or visibility:hidden
        var focusableElements = preliminaryFocusableEls.filter(function (currEl) {
            return (currEl.offsetHeight > 0 && getComputedStyle(currEl).visibility.toUpperCase() !== 'HIDDEN');
        });
        if (focusableElements) {
            this._firstFocusableModalEl = focusableElements[0];
            this._lastFocusableModalEl = focusableElements[focusableElements.length - 1];
        }
    };
    /**
     * Gets the `aria-labelledby` value for the modal dialog
     * @return an id that associates to a heading element within the modal
     */
    PvdModal.prototype.dialogAriaLabelledby = function () {
        if (!this.pvdAriaLabelledby && this.pvdAriaLabel) {
            return;
        }
        return this.pvdAriaLabelledby ? this.pvdAriaLabelledby : this.generatedHeadingId;
    };
    /**
     * Handles keydown events in modal dialog
     * @param e, keyboard event
     */
    PvdModal.prototype.dialogKeydownEvent = function (e) {
        switch (e.key) {
            case KeyboardKey.escape:
            case LegacyKeyboardKey.escape:
                e.preventDefault();
                // if key is esc, close the modal
                this.closeModalEventHandler();
            case KeyboardKey.tab:
            case LegacyKeyboardKey.tab:
                // if the key is tab, make sure focus stays trapped
                var activeEl = document.activeElement;
                if (e.shiftKey) {
                    // reverse tabbing
                    if (activeEl === this._firstFocusableModalEl) {
                        e.preventDefault();
                        this.focusLastModalElement();
                    }
                }
                else {
                    if (activeEl === this._lastFocusableModalEl) {
                        e.preventDefault();
                        this.focusFirstModalElement();
                    }
                }
            default:
                return;
        }
    };
    /**
     * Focuses into the modal's dialog
     */
    PvdModal.prototype.focusModalDialog = function () {
        if (this._modalDialogEl) {
            this._modalDialogEl.focus();
        }
    };
    /**
     * Focuses into the first focusable element within the modal
     */
    PvdModal.prototype.focusFirstModalElement = function () {
        if (this._firstFocusableModalEl) {
            this._firstFocusableModalEl.focus();
        }
    };
    /**
     * Focuses into the last focusable element within the modal
     */
    PvdModal.prototype.focusLastModalElement = function () {
        if (this._lastFocusableModalEl) {
            this._lastFocusableModalEl.focus();
        }
    };
    /**
     * Returns focus to the specified element. If no element is specified, returns
     * focus to the element on the document that had focus before the modal was
     * opened
     */
    PvdModal.prototype.focusLastActiveElement = function () {
        if (this.returnFocusEl) {
            this.returnFocusEl.focus();
        }
        else if (this._lastFocusableEl) {
            this._lastFocusableEl.focus();
        }
    };
    /**
     * Gets the last focusable element before the Modal opens, typically the trigger
     */
    PvdModal.prototype.captureLastFocusableEl = function () {
        this._lastFocusableEl = document.activeElement;
    };
    /**
     * Caches the width of the scrollbar as `this._scrollbarWidth`
     */
    PvdModal.prototype.setScrollbarWidth = function () {
        var scrollingEl = document.createElement('div');
        scrollingEl.classList.add('pvd-modal__scrollbar-measure');
        this.renderRoot.appendChild(scrollingEl);
        this._scrollbarWidth = scrollingEl.offsetWidth - scrollingEl.clientWidth;
        this.renderRoot.removeChild(scrollingEl);
    };
    /**
     * Sets `overflow:hidden` to body to prevent background scrolling
     */
    PvdModal.prototype.hidePageOverflow = function () {
        this.lockBackground();
        this._prevBackgroundOverflow = document.body.style.overflow;
        // placebo class to indicate modal is applying global styles
        document.body.classList.add("".concat(PvdModal.namespace, "-modal-open"));
        document.body.style.overflow = 'hidden';
    };
    /**
     * Prevent the background from shifting when overflow is hidden
     */
    PvdModal.prototype.lockBackground = function () {
        if (this.pvdPreventBackgroundShift && this.hasVerticalScrollbar) {
            this._prevBodyPaddingRight = getComputedStyle(document.body)['padding-right'];
            document.body.style.paddingRight = "calc(".concat(this._prevBodyPaddingRight, " + ").concat(this._scrollbarWidth, "px)");
        }
    };
    Object.defineProperty(PvdModal.prototype, "hasVerticalScrollbar", {
        /**
         * Determine if a vertical scrollbar is present
         *
         * @see https://tylercipriani.com/blog/2014/07/12/crossbrowser-javascript-scrollbar-detection/
         */
        get: function () {
            return window.innerWidth > document.documentElement.clientWidth;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Reset the changes made by {@link lockBackground}
     */
    PvdModal.prototype.unlockBackground = function () {
        if (this.pvdPreventBackgroundShift) {
            document.body.style.paddingRight = this._prevBodyPaddingRight;
        }
    };
    /**
     * Inspects the bounding boxes of the content and it's wrapper to determine if the content is scrolling
     */
    PvdModal.prototype.isContentOverflowing = function () {
        return __awaiter(this, void 0, void 0, function () {
            var slotArea, slotScrollHeight, wrapperRectHeight;
            return __generator(this, function (_a) {
                slotArea = this.querySelector('.pvd-modal__body-wrapper');
                slotScrollHeight = Math.round(slotArea === null || slotArea === void 0 ? void 0 : slotArea.scrollHeight);
                wrapperRectHeight = Math.round(slotArea === null || slotArea === void 0 ? void 0 : slotArea.getBoundingClientRect()['height']);
                // check if the slotted content is taller than the bounding box
                if (slotScrollHeight && wrapperRectHeight) {
                    this.pvdContentOverflow = slotScrollHeight > wrapperRectHeight;
                }
                return [2 /*return*/];
            });
        });
    };
    /**
     * Starts observations for changes on elements
     */
    PvdModal.prototype.observeMutations = function () {
        if (this._contentChangeObserver && this._modalDialogEl) {
            this._contentChangeObserver.observe(this._modalDialogEl, {
                attributes: true,
                childList: true,
                characterData: true,
                subtree: true,
            });
        }
    };
    /**
     * Evaluates the content within the Modal to see if change needs to occur for a11y purposes
     * TODO: make public once more appropriate name is considered
     */
    PvdModal.prototype.checkContent = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: 
                    // this MUST be complete before getting first/last focusable elements
                    // if not, it may not count the scroll container as the last focusable el if its just close button and scroll container
                    return [4 /*yield*/, this.isContentOverflowing()];
                    case 1:
                        // this MUST be complete before getting first/last focusable elements
                        // if not, it may not count the scroll container as the last focusable el if its just close button and scroll container
                        _a.sent();
                        this.addFirstLastFocusableElements();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Removes the mutation observers within Modal
     */
    PvdModal.prototype.removeMutationObservers = function () {
        if (this._contentChangeObserver) {
            this._contentChangeObserver.disconnect();
        }
    };
    /**
     * Resets the overflow of body to prevent previous state
     */
    PvdModal.prototype.resetPageOverflow = function () {
        this.unlockBackground();
        document.body.classList.remove("".concat(PvdModal.namespace, "-modal-open"));
        document.body.style.overflow = this._prevBackgroundOverflow;
    };
    /**
     * Sets the `max-height` of the modal dialog each time the modal is opened or resized
     * cannot use `max-height: 100vh` as it has issues in safari mobile
     * https://css-tricks.com/the-trick-to-viewport-units-on-mobile/
     */
    PvdModal.prototype.setMaxHeight = function () {
        var maxHeight = window.innerHeight;
        if (maxHeight && this._modalEl) {
            this._modalDialogEl.style.setProperty('--pvd-modal-dialog-max-height', "".concat(maxHeight, "px"));
        }
    };
    /**
     * Overrides z-index token of modal with pvdZIndex when higher z-index is needed
     */
    PvdModal.prototype.setZIndex = function () {
        if (this.pvdZIndex && this._modalEl) {
            this._modalEl.style.zIndex = this.pvdZIndex;
        }
    };
    /**
     * Detecting CSS Transitions Completion with JavaScript - https://davidwalsh.name/css-animation-callback
     * @return a string name of the proper cross-browser animation-end event name
     */
    PvdModal.prototype.whichAnimationEvent = function () {
        var el = document.createElement('fakeelement');
        var animations = {
            animation: 'animationend',
            OAnimation: 'oAnimationEnd',
            MozAnimation: 'animationend',
            WebkitAnimation: 'webkitAnimationEnd',
        };
        for (var a in animations) {
            if (el.style[a] !== undefined) {
                return animations[a];
            }
        }
    };
    ////////////
    // EVENTS //
    ////////////
    /**
     * Event to alert listeners that modal's open state has changed
     */
    PvdModal.prototype.triggerModalChangeEvent = function () {
        var event = new CustomEvent('pvd-modal-change', {
            detail: { state: this.pvdState, open: this.pvdOpen },
        });
        this.dispatchEvent(event);
    };
    /**
     * Mutation Observer callback for when content within Modal gets changed
     *
     * @param mutationsList
     * @param observer
     */
    PvdModal.prototype.contentChangeMutationEventHandler = function (mutationsList) {
        var _this = this;
        var mutations = mutationsList.filter(function (mutation) {
            // needed in order to support the change of an element that updates to display:none
            var validAttributeMutation = mutation.type === MutationType.attributes && mutation.attributeName === 'style';
            return (_this.pvdOpen &&
                (mutation.type === MutationType.characterData ||
                    mutation.type === MutationType.childList ||
                    validAttributeMutation));
        });
        if (mutations.length > 0) {
            this.checkContent();
        }
    };
    /**
     * Handles what occurs when the Modal overlay is clicked
     * @param e, click event
     */
    PvdModal.prototype.overlayClickEventHandler = function (e) {
        if (this._modalOverlayEl && e.target === this._modalOverlayEl) {
            this.closeModalEventHandler();
        }
    };
    /**
     * Handles when the window resizes, given the debounce
     */
    PvdModal.prototype.windowResizeHandler = function () {
        this.setMaxHeight();
        this.requestUpdate();
    };
    ////////////////
    // LIFECYCLES //
    ////////////////
    PvdModal.prototype.disconnectedCallback = function () {
        _super.prototype.disconnectedCallback.call(this);
        this.removeMutationObservers();
        if (this.pvdOpen) {
            /**
             * When someone closes the component, `openStateChange` is triggered and
             * will call `closing` and `closed` when the close animation starts and
             * ends, respectively.
             *
             * In this case, the component was removed from the DOM while it was
             * still open, so the `openStateChange` method will not be triggered, and
             * we need to call `closing` and `closed` ourselves.
             */
            this.closing();
            this.closed();
        }
    };
    PvdModal.prototype.firstUpdated = function () {
        _super.prototype.firstUpdated.call(this);
        this.addElementReferences();
        this.setScrollbarWidth();
    };
    PvdModal.prototype.updated = function (changedProperties) {
        _super.prototype.updated.call(this, changedProperties);
        // to handle when user tries to close the modal while it's still opening https://jira.fmr.com/browse/PUUCP-2253
        var isEdgeCase = !this.pvdOpen && changedProperties.get('pvdState') === ModalState.opening;
        if (changedProperties.has('pvdOpen') || isEdgeCase) {
            try {
                this.openStateChange();
            }
            catch (e) {
                // we leave this empty because it can fire before the component has finished setting up so we need to ignore that case
            }
        }
        if (changedProperties.has('pvdZIndex')) {
            this.setZIndex();
        }
        if (changedProperties.has('pvdParentEl')) {
            this.parentElCacheBust();
            this.appendToParentEl();
        }
        if (changedProperties.has('pvdReturnFocusEl')) {
            this.returnFocusElCacheBust();
        }
    };
    ////////////
    // RENDER //
    ////////////
    PvdModal.prototype.renderBody = function () {
        return x(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      <div\n        class=\"pvd-modal__body-wrapper\"\n        id=\"", "\"\n        role=\"", "\"\n        tabindex=\"", "\"\n      >\n        <s-slot></s-slot>\n      </div>\n    "], ["\n      <div\n        class=\"pvd-modal__body-wrapper\"\n        id=\"", "\"\n        role=\"", "\"\n        tabindex=\"", "\"\n      >\n        <s-slot></s-slot>\n      </div>\n    "])), l(this._generatedBodyId), l(this.pvdContentOverflow ? 'region' : undefined), l(this.pvdContentOverflow ? '0' : undefined));
    };
    PvdModal.prototype.renderCloseButton = function () {
        return x(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      <button class=\"pvd-modal__close-button\" @click=\"", "\" type=\"button\">\n        <span class=\"pvd-modal__close-button-a11y-text\">", "</span>\n        ", "\n      </button>\n    "], ["\n      <button class=\"pvd-modal__close-button\" @click=\"", "\" type=\"button\">\n        <span class=\"pvd-modal__close-button-a11y-text\">", "</span>\n        ", "\n      </button>\n    "])), this.closeModalEventHandler, this.pvdCloseButtonA11yText, this.renderCloseIcon());
    };
    PvdModal.prototype.renderCloseIcon = function () {
        return this
            .scopeTemplate(templateObject_3 || (templateObject_3 = __makeTemplateObject(["<pvd-scoped-icon pvd-name=\"action__close\" pvd-size=\"small\"></pvd-scoped-icon>"], ["<pvd-scoped-icon pvd-name=\"action__close\" pvd-size=\"small\"></pvd-scoped-icon>"])));
    };
    PvdModal.prototype.renderHeading = function () {
        return x(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n      ", "\n    "], ["\n      ", "\n    "])), this.isSlotUsed('heading')
            ? x(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n            <div class=\"pvd-modal__heading-wrapper\" id=\"", "\">\n              <s-slot name=\"heading\"></s-slot>\n            </div>\n          "], ["\n            <div class=\"pvd-modal__heading-wrapper\" id=\"", "\">\n              <s-slot name=\"heading\"></s-slot>\n            </div>\n          "])), l(this._generatedHeadingId)) : x(templateObject_5 || (templateObject_5 = __makeTemplateObject([" <s-slot name=\"heading\"></s-slot> "], [" <s-slot name=\"heading\"></s-slot> "]))));
    };
    PvdModal.prototype.render = function () {
        var classMap = {
            default: "".concat(this.constructor.namespace, "-modal-root"),
            modifierPrefix: 'pvd-modal',
            modifiers: [
                {
                    condition: this.pvdContentOverflow,
                    className: 'content-overflow',
                },
                {
                    condition: this.pvdModalWidth !== undefined,
                    className: "width-".concat(MODAL_WIDTH[this.pvdModalWidth] ? this.pvdModalWidth : DEFAULT_WIDTH),
                },
                {
                    condition: this.pvdState !== undefined,
                    className: this.pvdState,
                },
            ],
        };
        return x(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n      <div class=\"", "\">\n        <div\n          aria-hidden=\"true\"\n          class=\"pvd-modal__overlay\"\n          @click=\"", "\"\n        ></div>\n        <div\n          aria-describedby=\"", "\"\n          aria-labelledby=\"", "\"\n          aria-label=\"", "\"\n          aria-modal=\"true\"\n          class=\"pvd-modal__dialog\"\n          role=\"dialog\"\n          tabindex=\"0\"\n          @keydown=\"", "\"\n        >\n          <div class=\"pvd-modal__content\" role=\"document\">\n            ", " ", " ", "\n          </div>\n        </div>\n      </div>\n    "], ["\n      <div class=\"", "\">\n        <div\n          aria-hidden=\"true\"\n          class=\"pvd-modal__overlay\"\n          @click=\"", "\"\n        ></div>\n        <div\n          aria-describedby=\"", "\"\n          aria-labelledby=\"", "\"\n          aria-label=\"", "\"\n          aria-modal=\"true\"\n          class=\"pvd-modal__dialog\"\n          role=\"dialog\"\n          tabindex=\"0\"\n          @keydown=\"", "\"\n        >\n          <div class=\"pvd-modal__content\" role=\"document\">\n            ", " ", " ", "\n          </div>\n        </div>\n      </div>\n    "])), getClassName(classMap), this.overlayClickEventHandler, this.pvdAriaDescribedby || this.generatedBodyId, l(this.dialogAriaLabelledby()), l(this.pvdAriaLabel), this.dialogKeydownEvent, this.renderCloseButton(), this.renderHeading(), this.renderBody());
    };
    //#region Component configuration
    PvdModal.componentName = 'modal';
    __decorate([
        n({ type: String, reflect: true, attribute: 'pvd-aria-describedby' }),
        __metadata("design:type", String)
    ], PvdModal.prototype, "pvdAriaDescribedby", void 0);
    __decorate([
        n({ type: String, reflect: true, attribute: 'pvd-aria-label' }),
        __metadata("design:type", String)
    ], PvdModal.prototype, "pvdAriaLabel", void 0);
    __decorate([
        n({ type: String, reflect: true, attribute: 'pvd-aria-labelledby' }),
        __metadata("design:type", String)
    ], PvdModal.prototype, "pvdAriaLabelledby", void 0);
    __decorate([
        n({
            type: String,
            reflect: true,
            attribute: 'pvd-close-button-a11y-text',
        }),
        __metadata("design:type", String)
    ], PvdModal.prototype, "pvdCloseButtonA11yText", void 0);
    __decorate([
        n(_assign({ type: Boolean, reflect: true, attribute: 'pvd-intercept-close' }, PvdSlotifyBaseComponent.booleanAttribute('pvd-intercept-close'))),
        __metadata("design:type", Boolean)
    ], PvdModal.prototype, "pvdInterceptClose", void 0);
    __decorate([
        n(_assign({ type: Boolean, reflect: true, attribute: 'pvd-open' }, PvdSlotifyBaseComponent.booleanAttribute('pvd-open'))),
        __metadata("design:type", Boolean)
    ], PvdModal.prototype, "pvdOpen", void 0);
    __decorate([
        n(_assign({ type: Boolean, reflect: true, attribute: 'pvd-prevent-background-shift' }, PvdSlotifyBaseComponent.booleanAttribute('pvd-prevent-background-shift'))),
        __metadata("design:type", Boolean)
    ], PvdModal.prototype, "pvdPreventBackgroundShift", void 0);
    __decorate([
        n({
            type: String,
            reflect: true,
            attribute: 'pvd-state',
        }),
        __metadata("design:type", String)
    ], PvdModal.prototype, "pvdState", void 0);
    __decorate([
        n({
            type: String,
            reflect: true,
            attribute: 'pvd-modal-width',
        }),
        __metadata("design:type", String)
    ], PvdModal.prototype, "pvdModalWidth", void 0);
    __decorate([
        n({
            type: HTMLElement,
            reflect: false,
            attribute: 'pvd-parent-el',
        })
        // TODO: default to `document.body` in PVD 4
        ,
        __metadata("design:type", Object)
    ], PvdModal.prototype, "pvdParentEl", void 0);
    __decorate([
        n({
            type: HTMLElement,
            reflect: false,
            attribute: 'pvd-return-focus-el',
        }),
        __metadata("design:type", Object)
    ], PvdModal.prototype, "pvdReturnFocusEl", void 0);
    __decorate([
        n({
            type: String,
            reflect: true,
            attribute: 'pvd-z-index',
        }),
        __metadata("design:type", String)
    ], PvdModal.prototype, "pvdZIndex", void 0);
    __decorate([
        t(),
        __metadata("design:type", Boolean)
    ], PvdModal.prototype, "pvdContentOverflow", void 0);
    return PvdModal;
}(ScopedElementsMixin(PvdSlotifyBaseComponent)));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;

export { DEFAULT_CLOSE_BTN_TEXT, DEFAULT_INTERCEPT_CLOSE, DEFAULT_OPEN, DEFAULT_PREVENT_HORIZONTAL_SHIFT, DEFAULT_STATE, DEFAULT_WIDTH, MODAL_WIDTH, ModalState, PvdModal, WINDOW_RESIZE_DELAY };
